import Vue from 'vue'
import VueRouter from 'vue-router'


const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')

  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/Reg',
    name: 'Reg',
    component: () => import('../views/Reg.vue')
  },
  {
    path: '/subAccount',
    name: 'subAccount',
    component: () => import('../views/subAccount.vue')
  },
  {
    path: '/chatAdmin',
    name: 'chatAdmin',
    component: () => import('../views/chatAdmin.vue')
  },
  {
    path: '/chatCs',
    name: 'chatCs',
    component: () => import('../views/chatCs.vue')
  },
  {
    path: '/chatMerchant',
    name: 'chatMerchant',
    component: () => import('../views/chatMerchant.vue')
  },
  {
    path: '/chatRec',
    name: 'chatRec',
    component: () => import('../views/chatRec.vue')
  },
  {
    path: '/chatDetail',
    name: 'chatDetail',
    component: () => import('../views/chatDetail.vue')
  },
  {
    path: '/chatUser',
    name: 'chatUser',
    component: () => import('../views/chatUser.vue')
  },
  {
    path: '/StartChatForm',
    name: 'StartChatForm',
    component: () => import('../views/startChatForm.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
